export let props = ['data', 'itemWidth', 'height']
export let model = {
  boxWidth: 0
}
export let computed = {
  list () {
    if (!this.boxWidth) return []
    let result = []
    let boxWidth = this.boxWidth
    let itemWidth = +this.itemWidth || 150
    let data = this.data
    let pageSize = ~~(boxWidth / itemWidth) || 1
    for (let i = 0; i < data.length; i = i + pageSize) {
      result.push(data.slice(i, pageSize + i))
    }
    return result
  }
}
